// @file Detects overwrite hostname.

let overwrite_host = ''

if (
  typeof document !== 'undefined' &&
  document.documentElement &&
  document.documentElement.dataset &&
  document.documentElement.dataset.overwriteHost
) {
  overwrite_host = document.documentElement.dataset.overwriteHost
}

export default overwrite_host
